var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messageToViewer.length)?_c('div',{staticClass:"message-of-the-day"},[_c('UserProfileImage',{attrs:{"src":_vm.broadcasterUser.profileImg}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.messageToViewer))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }